// extracted by mini-css-extract-plugin
export default {"container":"ChartMetricCard_container__IGVyw","value":"ChartMetricCard_value__sz-GQ","title":"ChartMetricCard_title__f5l8E","description":"ChartMetricCard_description__rvHtx"};